import { KnowledgeLevel, knowledgeLevels } from "@goodfill/domain-customer-application-types";
import { InputCheckbox, Label } from "@goodfill/ui-components";
import React, { FocusEventHandler, forwardRef, Ref } from "react";
import { FieldGroup } from "../../../../../../form/FieldGroup";

const experienceLevelLabel: Record<KnowledgeLevel, KnowledgeLevel> = {
  None: "None",
  Limited: "Limited",
  Good: "Good",
  Extensive: "Extensive",
};

interface KnowledgeLevelProps {
  id: string;
  title: string;
  validation: string[];
  selected: KnowledgeLevel;
  onSelect: (value: KnowledgeLevel) => void;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  ref?: Ref<HTMLInputElement>;
  disabled?: boolean;
}

export const KnowledgeLevelField: React.FC<KnowledgeLevelProps> = forwardRef(
  ({ title, validation, selected, onSelect, onBlur, id, disabled }, ref) => {
    let first = true;

    return (
      <FieldGroup label={title} validation={validation}>
        <div className="flex px-2 md:px-3 flex-wrap">
          {knowledgeLevels.map((level) => {
            const inputId = `${id}${level}`;
            const checked = level === selected;

            const _ref = first ? ref : undefined;
            first = false;

            return (
              <div key={inputId} className="flex gap-1 items-center">
                <InputCheckbox
                  id={inputId}
                  checked={checked}
                  onChange={() => onSelect(level)}
                  onBlur={onBlur}
                  ref={_ref}
                  disabled={disabled}
                />
                <Label htmlFor={inputId} primary={checked}>
                  {experienceLevelLabel[level]}
                </Label>
              </div>
            );
          })}
        </div>
      </FieldGroup>
    );
  },
);
